import React, { useEffect, useState, useRef } from 'react'
import "../css/ProjectsTabSA.css"
import "../css/commonStyles.css"
import { notify } from '../utils/ToastUtils';
import TailwindModal from '../components/TailwindModal';
import moment from 'moment'
import ms from "ms";
import { useDispatch, useSelector } from "react-redux"
import { selectUser } from "src/stores/userSlice"
import { selectProjects ,fetchProjects } from 'src/stores/projectSlice';
import { selectEmployees } from 'src/stores/employeeSlice';
import { selectIsApiLoading } from "src/stores/loadingSlice";
import ApiClient from "../ApiClient"
import CentralizedTable from '../components/CentralizedTable';
import validator from 'validator'
import { TextField, Select as MuiSelect, MenuItem, InputAdornment, IconButton, Tooltip, Autocomplete, Avatar, AvatarGroup } from '@mui/material';
import { FolderPlus, Edit3, Briefcase, Search, PlusCircle, CheckCircle2, Trash2, Users, Hash, Calendar, User, X, Edit } from 'lucide-react';
import UserAvatar from '../components/UserAvatar';

function ProjectsTabSA() {
    const dispatch = useDispatch()
    let selectRef = useRef(null);
    let selectRef2 = useRef(null);
    const [modal, setModal] = useState(false)
    const [client, setClient] = useState('');
    const [updatedProj, setUpdatedProj] = useState({});
    const user = useSelector(selectUser)
    const projects = useSelector(selectProjects)
    const isApiLoading = useSelector(selectIsApiLoading);
    const [rows, setRows] = useState([])
    const [columns, setColumns] = useState([])
    const [minDate1, setMinDate1] = useState(null)
    const [minDate2, setMinDate2] = useState(null)
    const [editTab, setEditTab] = useState(false)
    const employees = useSelector(selectEmployees);
    const [isDisabled, setIsDisabled] = useState(false)
    const [currentActiveTab, setCurrentActiveTab] = useState('3');
    const [emailError, setEmailError] = useState('')
    const [tags, setTags] = useState([]);
    const [filterText, setFilterText] = useState('')
    const [tableTab, setTableTab] = useState('All');
    const [teamModal, setTeamModal] = useState(false);
    const [modalTeamMembers, setModalTeamMembers] = useState([]);
    const [teamSearchTerm, setTeamSearchTerm] = useState('');
    const openTeamModal = (teamString) => {
        let teamEmails = teamString ? teamString.split(",").map(e => e.trim()).filter(Boolean) : [];
        setModalTeamMembers(teamEmails);
        setTeamSearchTerm('');
        setTeamModal(true);
    }
    const toggle = tab => {
        if (currentActiveTab !== tab) {
            setCurrentActiveTab(tab);
        }
    }
    const [selectedOptions, setSelectedOptions] = useState([]);
    const selectHandleChange = (empOptions) => {
        setSelectedOptions(empOptions);
    }
    const [clientModalError, setClientModalError] = useState('');
    const [clientSubmitAttempted, setClientSubmitAttempted] = useState(false);
    const initialState = {
        clientName: "",
        projectID: "",
        projectName: "",
        startDt: "",
        endDt: "",
        poc: "",
        projDesc: "",
        client: "",
        projectCode: "",
        updatedID: "",
        updatedName: "",
        startDate: "",
        endDate: "",
        updatedPOC: "",
        updatedDesc: "",
        status: "",
        clientID: '',
        newClientName: '',
        startdate: '',
        clientGeo: '',
        clientContact: '',
        clientMail: '',
        clientPhone: '',
        clientParent: '',
        clientStatus: '',
    }
    const [state, setState] = useState(initialState)
    const activeEmployees = React.useMemo(() => {
        return (employees || []).filter((el) => el.STATUS === "Active")
    }, [employees]);
    const empOptions = React.useMemo(() => {
        return activeEmployees?.map(person => ({ value: person.EMP_WORK_EMAIL, label: person.EMP_NAME }))
    }, [activeEmployees]);

    useEffect(() => {
        // Update selected options when projectTeam changes (for edit modal)
        if (state.projectTeam) {
            let teamEmails = state.projectTeam.split(",").map(e => e.trim()).filter(Boolean);
            let options = empOptions.filter(opt => teamEmails.includes(opt.value));
            setSelectedOptions(options);
        } else {
            setSelectedOptions(prev => prev.length === 0 ? prev : []);
        }
    }, [state.projectTeam, empOptions]);

    function handleChange(evt) {
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
        setClientModalError('');
        if (evt.target.name === "clientMail") {
            if (validator.isEmail(value)) {
                setEmailError('Valid');
            } else {
                setEmailError('Enter valid Email!');
            }
        }
    }

    const editProjectDetails = (project) => {
        setEditTab(true)
        toggle('2');
        let data = {};
        let modifiedData = Object.assign(data, project);
        modifiedData.START_DATE = moment(modifiedData.START_DATE).format("YYYY-MM-DD")
        modifiedData.END_DATE = moment(modifiedData.END_DATE).format("YYYY-MM-DD")
        setUpdatedProj(modifiedData)
        setState({
            clientID:modifiedData.CLIENT_CODE,
            client: modifiedData.CLIENT_NAME,
            updatedID: modifiedData.PROJECT_ID,
            updatedName: modifiedData.PROJECT_NAME,
            startDate: modifiedData.START_DATE,
            endDate: modifiedData.END_DATE || undefined,
            updatedPOC: modifiedData.PROJECT_POC,
            updatedDesc: modifiedData.PROJECT_DESC,
            projectCode: modifiedData.PROJECT_CODE,
            status: modifiedData.PROJECT_STATUS
        });
        let team = modifiedData.PROJECT_TEAM ? modifiedData.PROJECT_TEAM.split(",").map(e => e.trim()).filter(Boolean) : [];
        let result = team?.map((el) => {
            return empOptions.find(item => item.value === el)
        }).filter(Boolean);
        setTags(result)
    }

    const updateProjectDetails = async () => {
        let projTeam = getProjAssignees();
        if (state.clientID && state.updatedID && state.updatedName && state.status && state.startDate && state.updatedPOC && projTeam && state.updatedDesc) {
            if (state.status === "Closed" && state.endDate === "Invalid date")
                notify.error("End Date is mandatory for project closure")
            else {
                let endDate = (state.endDate == "Invalid date") ? undefined : state.endDate
                setIsDisabled(true)
                try {
                    await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/admin/editProject`, {
                        projID: state.updatedID,
                        projName: state.updatedName,
                        clientCode: state.clientID,
                        startDate: state.startDate,
                        endDate,
                        poc: state.updatedPOC,
                        status: state.status,
                        projTeam,
                        projDesc: state.updatedDesc,
                        projectCode: state.projectCode
                    })
                    notify.success("Project updated successfully")
                    dispatch(fetchProjects())
                    setState(initialState);
                    setTags([]);
                    setIsDisabled(false)
                    toggle('3');
                } catch (error) {
                    console.log(error)
                    setIsDisabled(false)
                    let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
                    notify.error(errmsg)
                }
            }
        } else {
            notify.error("All fields are mandatory")
        }
    }

    const getProjAssignees = () => {
        let projTeam = [];
        let rawData = (selectedOptions.length > 0) ? selectedOptions : tags;
        projTeam = rawData?.map((emp) => {
            return emp?.value
        }).join()
        return projTeam;
    }

    const getClient = async () => {
        try {
            const { data } = await ApiClient.get(`${process.env.REACT_APP_BASE_URL}/admin/getClient`)
            setClient(data)
        }
        catch (error) {
            console.log(error)
            // let errmsg = (error?.response?.data?.message) ? (error?.response?.data?.message) : (`${error?.response?.status} - ${error?.response?.statusText}`)
            let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
            notify.error(errmsg)
        }
    }

    const addNewProject = async () => {
        let projTeam = getProjAssignees();
        if (state.clientName && state.projectID && state.projectName && state.startDt && state.poc && projTeam && state.projDesc) {
            setIsDisabled(true)
            try {
                await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/admin/addNewProject`, {
                    projID: state.projectID,
                    projName: state.projectName,
                    clientCode: state.clientName,
                    startDate: state.startDt,
                    endDate: state.endDt || undefined,
                    poc: state.poc,
                    projTeam,
                    projDesc: state.projDesc,
                    createdBy: user?.name
                })
                setState(initialState)
                setSelectedOptions([])
                notify.success("Project added successfully")
                setIsDisabled(false)
                dispatch(fetchProjects())
                toggle('3');
                // console.log(useSelector(selectProjects));
            } catch (error) {
                setIsDisabled(false)
                let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
                notify.error(errmsg)
            }
        } else {
            notify.error("All fields are mandatory except End Date")
        }
    }

    const getProjectDetails = () => {
        const renderCellTooltip = (params) => (
            <Tooltip title={params.value || ""}>
                <span className="block truncate w-full overflow-hidden text-ellipsis whitespace-nowrap min-w-0">{params.value || "-"}</span>
            </Tooltip>
        );

        let projectTableCols = [{
            headerName: "Client Name",
            field: "CLIENT_NAME",
            sortable: true,
            width: 120,
            renderCell: renderCellTooltip
        }, {
            headerName: "Project ID",
            field: "PROJECT_ID",
            sortable: true,
            width: 100,
            renderCell: renderCellTooltip
        }, {
            headerName: "Project Name",
            field: "PROJECT_NAME",
            sortable: true,
            width: 200,
            renderCell: renderCellTooltip
        }, {
            headerName: "Team Members",
            field: "PROJECT_TEAM",
            sortable: false,
            width: 180,
            renderCell: (params) => {
                if (!params.row.PROJECT_TEAM) return "-";
                let teamEmails = params.row.PROJECT_TEAM.split(",").map(e => e.trim()).filter(Boolean);
                let visibleCount = 3;
                let visibleEmails = teamEmails.slice(0, visibleCount);
                let extraCount = teamEmails.length - visibleCount;
                return (
                    <Tooltip title="View all members">
                        <div className="flex items-center pl-2 cursor-pointer group mx-2" onClick={() => openTeamModal(params.row.PROJECT_TEAM)}>
                            {visibleEmails.map((email, index) => {
                                let emp = employees?.find(e => e.EMP_WORK_EMAIL === email);
                                let name = emp ? emp.EMP_NAME : email;
                                return (
                                    <div key={index} className="-ml-2 relative group-hover:z-10 transition-transform">
                                        <UserAvatar name={name} size={28} />
                                    </div>
                                )
                            })}
                            {extraCount > 0 && (
                                <div 
                                    className="-ml-2 relative border border-white shadow-sm rounded-full bg-slate-100 flex items-center justify-center text-slate-600 text-[11px] font-bold group-hover:z-10"
                                    style={{ width: 28, height: 28 }}
                                >
                                    +{extraCount}
                                </div>
                            )}
                        </div>
                    </Tooltip>
                );
            }
        },{
            headerName: "Description",
            field: "PROJECT_DESC",
            sortable: true,
            width: 220,
            valueGetter: (params) => {
                return (params.row?.PROJECT_DESC && params.row?.PROJECT_DESC !== "NULL") ? params.row?.PROJECT_DESC : "-";
            },
            renderCell: renderCellTooltip
        }, {
            headerName: "Status",
            field: "PROJECT_STATUS",
            sortable: true,
            width: 120,
            renderCell: (params) => {
                const status = params.row.PROJECT_STATUS;
                const isActive = status === 'Open' || status === 'Active';
                return (
                    <span className={`px-2.5 py-1 rounded-full text-[11px] font-semibold flex items-center gap-1.5 w-max ${isActive ? 'bg-green-50 text-green-700 border border-green-200' : 'bg-slate-100 text-slate-700 border border-slate-200'}`}>
                        <span className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-green-500' : 'bg-slate-400'}`}></span>
                        {status || 'Closed'}
                    </span>
                )
            }
        }, {
            headerName: "POC",
            field: "PROJECT_POC",
            sortable: true,
            width: 250,
            renderCell: (params) => {
                const pocEmail = params.row.PROJECT_POC;
                if (!pocEmail || pocEmail === "NULL") return <span className="text-slate-400 italic font-medium text-[13px]">Not Assigned</span>;
                
                const empInfo = employees?.find(e => e.EMP_WORK_EMAIL === pocEmail);
                const empName = empInfo ? empInfo.EMP_NAME : pocEmail.split('@')[0];
                
                return (
                    <div className="flex items-center gap-3 w-full max-w-full">
                        <UserAvatar name={empName} size={36} />
                        <div className="flex flex-col justify-center items-start min-w-0 flex-1 overflow-hidden">
                            <Tooltip title={empName} placement="top" arrow disableInteractive>
                                <h3 className="text-[14px] font-semibold text-slate-800 m-0 leading-tight truncate cursor-default max-w-full">{empName}</h3>
                            </Tooltip>
                            <Tooltip title={pocEmail} placement="right" arrow disableInteractive>
                                <p className="text-[12px] font-medium text-slate-500 m-0 lowercase mt-0.5 truncate cursor-default max-w-full">{pocEmail}</p>
                            </Tooltip>
                        </div>
                    </div>
                )
            }
        }, {
            headerName: "Start Date",
            field: "START_DATE",
            sortable: true,
            width: 110,
            valueGetter: (params) => {
                return moment(params.row?.START_DATE).format("DD-MMM-YYYY");
            },
            renderCell: renderCellTooltip
        }, {
            headerName: "End Date",
            field: "END_DATE",
            sortable: true,
            width: 110,
            valueGetter: (params) => {
                return (params.row?.END_DATE) ? moment(params.row?.END_DATE).format("DD-MMM-YYYY") : "-";
            },
            renderCell: renderCellTooltip
        },  {
            headerName: "Action",
            field: "Action",
            sortable: false,
            width: 70,
            renderCell: (params) => (
                <div className='flex items-center justify-center'>
                <Tooltip title="Edit Project">
                    <button onClick={() => editProjectDetails(params.row)} className="w-7 h-7 rounded border border-blue-100 text-blue-500 flex items-center justify-center hover:bg-blue-50 transition-colors bg-white shadow-sm">
                        <Edit size={12} strokeWidth={2.5} />
                    </button>
                </Tooltip>
                </div>
            )
        }]
        setColumns(projectTableCols)
        setRows(projects)
    }

    const clearData = () => {
        setState(initialState);
        setSelectedOptions([]);
        setTags([]);
    }

    const addNewClient = async () => {
        setClientModalError('');
        setClientSubmitAttempted(true);
        if (!state.clientID || !state.newClientName || !state.startdate || !state.clientMail || !state.clientStatus) {
            setClientModalError("Please enter input for mandatory fields")
            return;
        }
        if (emailError !== "Valid") {
            setClientModalError("Please enter a valid email address");
            return;
        }

        const nameExists = client?.some(obj => obj?.CLIENT_NAME?.toLowerCase() === state?.newClientName?.toLowerCase());
        const idExists = client?.some(obj => obj?.CLIENT_ID?.toLowerCase() === state?.clientID?.toLowerCase());
        
        if (nameExists) {
            setClientModalError("Client Name already exists");
            return;
        }
        if (idExists) {
            setClientModalError("Client ID already exists");
            return;
        }

        setIsDisabled(true)
        try {
            await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/admin/addNewClient`, {
                id: state.clientID,
                name: state.newClientName,
                date: state.startdate,
                geo: state.clientGeo,
                contact: state.clientContact,
                email: state.clientMail,
                phone: state.clientPhone,
                parent: state.clientParent,
                status: state.clientStatus
            })
            setState(initialState)
            setClientModalError('');
            setModal(false)
            notify.success(`Client ${state.newClientName} added successfully`)
            setIsDisabled(false)
            getClient();
        } catch (error) {
            console.log(error)
            setIsDisabled(false)
            let errmsg = (error?.response) ? (error?.response?.data?.message ? error?.response?.data?.message : `${error?.response?.status} - ${error?.response?.statusText}`) : "Something went wrong. Please try again later"
            setClientModalError(errmsg)
        }
    }

    const initDateRangeForAdd = () => {
        const minsec = ms('0d')
        const min_date = new Date(new Date(state.startDt) - minsec);
        setMinDate1(moment(min_date).format('YYYY-MM-DD'));
    }

    const searchTable = (event) => {
        // let input = document.getElementById('searchInput').value
        setFilterText(event.target.value)
    }
    const filteredRows = React.useMemo(() => {
        let result = rows.filter((row) => {
            const searchStr = (filterText || '').toLowerCase();
            let matchesSearch = String(row?.PROJECT_NAME || '').toLowerCase().includes(searchStr) ||
                String(row?.CLIENT_NAME || '').toLowerCase().includes(searchStr) ||
                String(row?.PROJECT_DESC || '').toLowerCase().includes(searchStr) ||
                String(row?.PROJECT_ID || '').toLowerCase().includes(searchStr);
                
            let matchesTab = true;
            let isActive = row?.PROJECT_STATUS === 'Open' || row?.PROJECT_STATUS === 'Active';
            if (tableTab === 'Active') matchesTab = isActive;
            if (tableTab === 'Inactive') matchesTab = !isActive;
            
            return matchesSearch && matchesTab;
        });
        return result.sort((a, b) => String(a?.PROJECT_NAME || '').localeCompare(String(b?.PROJECT_NAME || '')));
    }, [rows, filterText, tableTab]);

    const initDateRangeForEdit = () => {
        const minsec = ms('0d')
        const min_date = new Date(new Date(state.startDate) - minsec);
        setMinDate2(moment(min_date).format('YYYY-MM-DD'));
    }

    useEffect(() => {
        initDateRangeForAdd();
    }, [state.startDt]);

    useEffect(() => {
        getProjectDetails()
    }, [projects])

    useEffect(() => {
        initDateRangeForEdit();
    }, [state.startDate]);

    useEffect(() => {
        getClient();
        getProjectDetails();
    }, [])

    const TabButton = ({ id, label, isVisible = true }) => {
        if (!isVisible) return null;
        return (
            <button
                className={`whitespace-nowrap px-4 py-2.5 text-sm font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1 ${
                    currentActiveTab === id 
                        ? 'bg-white text-brand-700 shadow-sm border border-slate-200/60' 
                        : 'text-slate-600 hover:text-slate-900 hover:bg-slate-200/50 border border-transparent'
                }`}
                onClick={(e) => { e.preventDefault(); toggle(id); }}
            >
                {label}
            </button>
        );
    };

    return (
        <div className="flex flex-col w-full space-y-4">
            
            {/* Tabs & Form Card */}
            {currentActiveTab !== '3' && (
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 xl:p-5">
                <div className="hidden">
                    <TabButton id="1" label="Add New Project" />
                    <TabButton id="2" label="Edit Project" isVisible={editTab} />
                </div>

                {currentActiveTab === '1' && (
                    <div className="space-y-4 pb-6 xl:pb-8">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-4">
                            <div className="flex items-center gap-3">
                                <button type="button" onClick={() => { clearData(); toggle('3'); }} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors -ml-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                                </button>
                                <div className="p-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-100">
                                    <FolderPlus size={20} />
                                </div>
                                <div>
                                    <h2 className="text-[16px] font-bold text-slate-800 m-0 leading-tight">Add New Project</h2>
                                    <p className="text-xs text-slate-500 font-medium mt-0.5 block m-0">Create a new project and assign a team</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <button type="button" className="px-5 py-2 border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 font-medium text-sm flex items-center gap-2 transition-colors shadow-sm" onClick={() => { clearData(); toggle('3'); }}>
                                    <Trash2 size={16} /> Discard
                                </button>
                                <button type="button" className={`px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-sm flex items-center gap-2 transition-colors shadow-sm ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={addNewProject} disabled={isDisabled}>
                                    {isDisabled ? <><span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Loading...</> : "Save Project"}
                                </button>
                            </div>
                        </div>

                        {/* Section 1 */}
                        <div>
                             <h3 className="text-blue-600 font-semibold text-sm mb-3">Project Information</h3>
                             <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                 <div>
                                     <div className="flex justify-between mb-1">
                                         <label className="block text-sm font-semibold text-slate-700">Client <span className="text-red-500">*</span></label>
                                         {user?.role === "Admin" && (
                                             <button type="button" className="text-blue-600 hover:text-blue-700 text-xs font-semibold flex items-center gap-1" onClick={() => setModal(true)}>
                                                <PlusCircle size={12}/> Add New
                                             </button>
                                         )}
                                     </div>
                                     <Autocomplete
                                         options={client ? client.filter((v, i, a) => a.findIndex(t => (t.CLIENT_NAME === v.CLIENT_NAME)) === i) : []}
                                         getOptionLabel={(option) => option.CLIENT_NAME || ""}
                                         value={client?.find(el => el.CLIENT_CODE === state.clientName) || null}
                                         isOptionEqualToValue={(option, value) => option.CLIENT_CODE === value?.CLIENT_CODE}
                                         onChange={(event, newValue) => {
                                             handleChange({ target: { name: 'clientName', value: newValue ? newValue.CLIENT_CODE : '' } });
                                         }}
                                         size="small"
                                         className="w-full bg-white"
                                         sx={{ '& .MuiOutlinedInput-root': { padding: '2px 8px', height: '38px' }, '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } }}
                                         ListboxProps={{ style: { maxHeight: 250, fontSize: '14px' } }}
                                         renderInput={(params) => (
                                             <TextField 
                                                 {...params}
                                                 required
                                                 placeholder="Select Client"
                                                 InputProps={{ 
                                                     ...params.InputProps,
                                                     startAdornment: (
                                                         <>
                                                             <InputAdornment position="start" sx={{ ml: 1 }}>
                                                                 <Briefcase size={16} className="text-slate-400"/>
                                                             </InputAdornment>
                                                             {params.InputProps.startAdornment}
                                                         </>
                                                     )
                                                 }} 
                                             />
                                         )}
                                     />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project Name <span className="text-red-500">*</span></label>
                                     <TextField size="small" name="projectName" placeholder="Enter Project Name" value={state.projectName} onChange={handleChange} className="w-full bg-white" required InputProps={{ startAdornment: <InputAdornment position="start"><FolderPlus size={16} className="text-slate-400"/></InputAdornment> }} />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project Status <span className="text-red-500">*</span></label>
                                     <TextField select size="small" value="Open" disabled className="w-full bg-slate-50"
                                         sx={{ '& .MuiOutlinedInput-root': { height: '36px' } }}>
                                         <MenuItem value="Open" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>
                                            <div className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-green-500"></span> Open</div>
                                         </MenuItem>
                                     </TextField>
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project ID <span className="text-red-500">*</span></label>
                                     <TextField size="small" name="projectID" placeholder="Enter Project ID" value={state.projectID} onChange={handleChange} className="w-full bg-white" required InputProps={{ startAdornment: <InputAdornment position="start"><Hash size={16} className="text-slate-400"/></InputAdornment> }} />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                     <TextField size="small" type="date" name="startDt" value={state.startDt} onChange={handleChange} className="w-full bg-white" required InputLabelProps={{ shrink: true }} InputProps={{ startAdornment: <InputAdornment position="start"><Calendar size={16} className="text-slate-400"/></InputAdornment> }} />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">End Date</label>
                                     <TextField size="small" type="date" name="endDt" value={state.endDt} onChange={handleChange} inputProps={{ min: minDate1 }} className="w-full bg-white" InputLabelProps={{ shrink: true }} InputProps={{ startAdornment: <InputAdornment position="start"><Calendar size={16} className="text-slate-400"/></InputAdornment> }} />
                                 </div>
                                 
                                 <div className="md:col-span-3">
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Point Of Contact <span className="text-red-500">*</span></label>
                                     <Autocomplete
                                         options={employees?.filter((el) => el.STATUS === "Active") || []}
                                         getOptionLabel={(option) => option.EMP_NAME}
                                         value={employees?.find(el => el.EMP_WORK_EMAIL === state.poc) || null}
                                         onChange={(event, newValue) => {
                                             handleChange({ target: { name: 'poc', value: newValue ? newValue.EMP_WORK_EMAIL : '' } });
                                         }}
                                         size="small"
                                         className="w-full bg-white"
                                         sx={{ '& .MuiOutlinedInput-root': { padding: '2px 8px', height: '38px' }, '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } }}
                                         ListboxProps={{ style: { maxHeight: 250, fontSize: '14px' } }}
                                         renderInput={(params) => (
                                             <TextField 
                                                 {...params}
                                                 required
                                                 placeholder="Select POC"
                                                 InputProps={{ 
                                                     ...params.InputProps,
                                                     startAdornment: (
                                                         <>
                                                             <InputAdornment position="start" sx={{ ml: 1 }}>
                                                                 <User size={16} className="text-slate-400"/>
                                                             </InputAdornment>
                                                             {params.InputProps.startAdornment}
                                                         </>
                                                     )
                                                 }} 
                                             />
                                         )}
                                     />
                                 </div>
                             </div>
                        </div>
                        
                        {/* Section 2 and 3 */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 border-t border-slate-100 pt-4 mb-6">
                             {/* 2. Assignment */}
                             <div>
                                  <h3 className="text-blue-600 font-semibold text-sm mb-3">Team Members</h3>
                                  <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 h-full">
                                      <label className="block text-sm font-semibold text-slate-700 mb-1">Assign project members<span className="text-red-500">*</span></label>
                                      <Autocomplete
                                          multiple
                                          disableCloseOnSelect
                                          options={empOptions}
                                          getOptionLabel={(option) => option.label}
                                          value={selectedOptions}
                                          onChange={(e, newValue) => selectHandleChange(newValue)}
                                          isOptionEqualToValue={(option, value) => option.value === value.value}
                                          renderOption={(props, option) => <li {...props} style={{ fontSize: '14px' }}>{option.label}</li>}
                                          ListboxProps={{ style: { maxHeight: 250 } }}
                                          renderTags={() => null}
                                          renderInput={(params) => (
                                              <TextField
                                                  {...params}
                                                  variant="outlined"
                                                  size="small"
                                                  placeholder="Search by name, email or role..."
                                                  className="bg-white"
                                                  sx={{ 
                                                      '& .MuiOutlinedInput-root': { padding: '2px 8px', minHeight: '36px' },
                                                      '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } 
                                                  }}
                                                  InputProps={{
                                                      ...params.InputProps,
                                                      startAdornment: (
                                                          <>
                                                              <InputAdornment position="start" sx={{ ml: 1 }}><Search size={16} className="text-slate-400" /></InputAdornment>
                                                              {params.InputProps.startAdornment}
                                                          </>
                                                      )
                                                  }}
                                              />
                                          )}
                                      />
                                      <div className="mt-4 flex items-center gap-2 text-blue-600">
                                          <Users size={16} />
                                          <span className="text-sm font-semibold">{selectedOptions.length} team members selected</span>
                                      </div>
                                      <div className="mt-3">
                                          <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto pr-2">
                                               {selectedOptions.length === 0 ? (
                                                   <div className="w-full text-center py-2 text-slate-400 text-sm italic">
                                                       No members added
                                                   </div>
                                               ) : selectedOptions.map((option) => {
                                                   return (
                                                       <div key={option.value} className="flex items-center gap-1.5 bg-blue-50/80 border border-blue-100 rounded-full py-1.5 pl-3 pr-2.5">
                                                           <span className="text-xs font-semibold text-slate-700">{option.label}</span>
                                                           <button type="button" onClick={() => selectHandleChange(selectedOptions.filter(t => t.value !== option.value))} className="text-slate-400 hover:text-slate-600 ml-1">
                                                               <X size={14} />
                                                           </button>
                                                       </div>
                                                   )
                                               })}
                                          </div>
                                      </div>
                                  </div>
                             </div>
                             
                             {/* 3. Additional Details */}
                             <div>
                                  <h3 className="text-blue-600 font-semibold text-sm mb-3"> Description</h3>
                                  <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 h-full flex flex-col">
                                      <label className="block text-sm font-semibold text-slate-700 mb-2">Project overview <span className="text-red-500">*</span></label>
                                      <TextField 
                                          size="small" 
                                          multiline 
                                          rows={4}
                                          name="projDesc" 
                                          value={state.projDesc || ''} 
                                          onChange={handleChange} 
                                          className="w-full bg-white" 
                                          required 
                                      />
                                      <div className="flex justify-between items-center mt-2">
                                          <p className="text-xs text-slate-500">Provide a brief description about the project</p>
                                          <div className="text-right text-xs font-medium text-slate-400">
                                              {state.projDesc?.length || 0} / 500
                                          </div>
                                      </div>
                                  </div>
                             </div>
                        </div>
                    </div>
                )}

                {currentActiveTab === '2' && (
                    <div id="editProjectContainer" className="space-y-4 pb-6 xl:pb-8">
                        <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-2 gap-4">
                            <div className="flex items-center gap-3">
                                <button type="button" onClick={() => { clearData(); toggle('3'); }} className="p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors -ml-2">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                                </button>
                                <div className="p-2 bg-blue-50 text-blue-600 rounded-lg border border-blue-100">
                                    <Edit3 size={20} />
                                </div>
                                <div>
                                    <h2 className="text-[16px] font-bold text-slate-800 m-0 leading-tight">Edit Project</h2>
                                    <p className="text-xs text-slate-500 font-medium mt-0.5 block m-0">Update details for {state.updatedName}</p>
                                </div>
                            </div>
                            <div className="flex items-center gap-3">
                                <button type="button" className="px-5 py-2 border border-slate-200 text-slate-700 rounded-lg hover:bg-slate-50 font-medium text-sm flex items-center gap-2 transition-colors shadow-sm" onClick={() => { clearData(); toggle('3'); }}>
                                    <Trash2 size={16} /> Discard
                                </button>
                                <button type="button" className={`px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium text-sm flex items-center gap-2 transition-colors shadow-sm ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={updateProjectDetails} disabled={isDisabled}>
                                    {isDisabled ? <><span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>Loading...</> : "Update Project"}
                                </button>
                            </div>
                        </div>

                        {/* Section 1 */}
                        <div>
                             <h3 className="text-blue-600 font-semibold text-sm mb-3">1. Project Information</h3>
                             <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Client <span className="text-red-500">*</span></label>
                                     <Autocomplete
                                         options={[{ CLIENT_NAME: state.client }]}
                                         getOptionLabel={(option) => option.CLIENT_NAME || ""}
                                         value={{ CLIENT_NAME: state.client }}
                                         disabled
                                         size="small"
                                         className="w-full bg-slate-50"
                                         sx={{ '& .MuiOutlinedInput-root': { padding: '2px 8px', height: '38px' }, '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } }}
                                         renderInput={(params) => (
                                             <TextField 
                                                 {...params}
                                                 InputProps={{ 
                                                     ...params.InputProps,
                                                     startAdornment: (
                                                         <>
                                                             <InputAdornment position="start" sx={{ ml: 1 }}>
                                                                 <Briefcase size={16} className="text-slate-400"/>
                                                             </InputAdornment>
                                                             {params.InputProps.startAdornment}
                                                         </>
                                                     )
                                                 }} 
                                             />
                                         )}
                                     />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project Name <span className="text-red-500">*</span></label>
                                     <TextField 
                                         size="small" 
                                         name="updatedName" 
                                         value={state.updatedName || ''} 
                                         disabled 
                                         className="w-full bg-slate-50" 
                                         InputProps={{ startAdornment: <InputAdornment position="start"><FolderPlus size={16} className="text-slate-400"/></InputAdornment> }}
                                     />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project Status <span className="text-red-500">*</span></label>
                                     <TextField 
                                         select
                                         size="small" 
                                         name="status" 
                                         value={state.status || ''} 
                                         onChange={handleChange} 
                                         required 
                                         className="w-full bg-white"
                                         sx={{ '& .MuiOutlinedInput-root': { height: '36px' } }}
                                         SelectProps={{ MenuProps: { PaperProps: { style: { maxHeight: 250 } } } }}
                                     >
                                         <MenuItem value="Open" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>
                                            <div className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-green-500"></span> Open</div>
                                         </MenuItem>
                                         <MenuItem value="Closed" sx={{ fontSize: '14px', minHeight: '32px', py: 0.5 }}>
                                            <div className="flex items-center gap-2"><span className="w-1.5 h-1.5 rounded-full bg-slate-400"></span> Closed</div>
                                         </MenuItem>
                                     </TextField>
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Project ID <span className="text-red-500">*</span></label>
                                     <TextField 
                                         size="small" 
                                         name="updatedID" 
                                         value={state.updatedID || ''} 
                                         disabled 
                                         className="w-full bg-slate-50" 
                                         InputProps={{ startAdornment: <InputAdornment position="start"><Hash size={16} className="text-slate-400"/></InputAdornment> }}
                                     />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Start Date <span className="text-red-500">*</span></label>
                                     <TextField 
                                         size="small" 
                                         type="date" 
                                         name="startDate" 
                                         value={state.startDate || ''} 
                                         disabled 
                                         className="w-full bg-slate-50" 
                                         InputProps={{ startAdornment: <InputAdornment position="start"><Calendar size={16} className="text-slate-400"/></InputAdornment> }}
                                     />
                                 </div>
                                 
                                 <div>
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">End Date <span className="text-red-500">*</span></label>
                                     <TextField 
                                         size="small" 
                                         type="date" 
                                         name="endDate" 
                                         value={state.endDate || ''} 
                                         onChange={handleChange} 
                                         inputProps={{ min: minDate2 }} 
                                         required 
                                         className="w-full bg-white" 
                                         InputLabelProps={{ shrink: true }}
                                         InputProps={{ startAdornment: <InputAdornment position="start"><Calendar size={16} className="text-slate-400"/></InputAdornment> }}
                                     />
                                 </div>
                                 
                                 <div className="md:col-span-3">
                                     <label className="block text-sm font-semibold text-slate-700 mb-1">Point Of Contact <span className="text-red-500">*</span></label>
                                     <Autocomplete
                                         options={employees?.filter((el) => el.STATUS === "Active") || []}
                                         getOptionLabel={(option) => option.EMP_NAME}
                                         value={employees?.find(el => el.EMP_WORK_EMAIL === state.updatedPOC) || null}
                                         onChange={(event, newValue) => {
                                             handleChange({ target: { name: 'updatedPOC', value: newValue ? newValue.EMP_WORK_EMAIL : '' } });
                                         }}
                                         size="small"
                                         className="w-full bg-white"
                                         sx={{ '& .MuiOutlinedInput-root': { padding: '2px 8px', height: '38px' }, '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } }}
                                         ListboxProps={{ style: { maxHeight: 250, fontSize: '14px' } }}
                                         renderInput={(params) => (
                                             <TextField 
                                                 {...params}
                                                 required
                                                 placeholder="Select POC"
                                                 InputProps={{ 
                                                     ...params.InputProps,
                                                     startAdornment: (
                                                         <>
                                                             <InputAdornment position="start" sx={{ ml: 1 }}>
                                                                 <User size={16} className="text-slate-400"/>
                                                             </InputAdornment>
                                                             {params.InputProps.startAdornment}
                                                         </>
                                                     )
                                                 }} 
                                             />
                                         )}
                                     />
                                 </div>
                             </div>
                        </div>

                        {/* Section 2 and 3 */}
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 border-t border-slate-100 pt-4 mb-6">
                             {/* 2. Assignment */}
                             <div>
                                  <h3 className="text-blue-600 font-semibold text-sm mb-3">Team Members</h3>
                                  <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 h-full">
                                      <label className="block text-sm font-semibold text-slate-700 mb-1">Assign project members <span className="text-red-500">*</span></label>
                                      <Autocomplete
                                          multiple
                                          options={empOptions}
                                          getOptionLabel={(option) => option.label}
                                          value={tags}
                                          disableCloseOnSelect
                                          onChange={(e, newValue) => setTags(newValue)}
                                          isOptionEqualToValue={(option, value) => option.value === value.value}
                                          renderOption={(props, option) => <li {...props} style={{ fontSize: '14px' }}>{option.label}</li>}
                                          ListboxProps={{ style: { maxHeight: 250 } }}
                                          renderTags={() => null} 
                                          renderInput={(params) => (
                                              <TextField
                                                  {...params}
                                                  variant="outlined"
                                                  size="small"
                                                  placeholder="Search by name, email or role..."
                                                  className="bg-white"
                                                  sx={{ 
                                                      '& .MuiOutlinedInput-root': { padding: '2px 8px', minHeight: '36px' },
                                                      '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } 
                                                  }}
                                                  InputProps={{
                                                      ...params.InputProps,
                                                      startAdornment: (
                                                          <>
                                                              <InputAdornment position="start" sx={{ ml: 1 }}><Search size={16} className="text-slate-400" /></InputAdornment>
                                                              {params.InputProps.startAdornment}
                                                          </>
                                                      )
                                                  }}
                                              />
                                          )}
                                      />
                                      
                                      <div className="mt-4 flex items-center gap-2 text-blue-600">
                                          <Users size={16} />
                                          <span className="text-sm font-semibold">{tags.length} team members selected</span>
                                      </div>
                                      
                                      <div className="mt-3">
                                          <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto pr-2">
                                               {tags.length === 0 ? (
                                                   <div className="w-full text-center py-2 text-slate-400 text-sm italic">
                                                       No members added
                                                   </div>
                                               ) : tags.map((option) => {
                                                   return (
                                                       <div key={option.value} className="flex items-center gap-1.5 bg-blue-50/80 border border-blue-100 rounded-full py-1.5 pl-3 pr-2.5">
                                                           <span className="text-xs font-semibold text-slate-700">{option.label}</span>
                                                           <button type="button" onClick={() => setTags(tags.filter(t => t.value !== option.value))} className="text-slate-400 hover:text-slate-600 ml-1">
                                                               <X size={14} />
                                                           </button>
                                                       </div>
                                                   )
                                               })}
                                          </div>
                                      </div>
                                  </div>
                             </div>
                             
                             {/* 3. Additional Details */}
                             <div>
                                  <h3 className="text-blue-600 font-semibold text-sm mb-3"> Description</h3>
                                  <div className="bg-slate-50/50 p-4 rounded-xl border border-slate-100 h-full flex flex-col">
                                      <label className="block text-sm font-semibold text-slate-700 mb-2">Project overview <span className="text-red-500">*</span></label>
                                      <TextField 
                                          size="small" 
                                          multiline 
                                          rows={4}
                                          name="updatedDesc" 
                                          value={state.updatedDesc || ''} 
                                          onChange={handleChange} 
                                          className="w-full bg-white" 
                                          required 
                                      />
                                      <div className="flex justify-between items-center mt-2">
                                          <p className="text-xs text-slate-500">Provide a brief description about the project</p>
                                          <div className="text-right text-xs font-medium text-slate-400">
                                              {state.updatedDesc?.length || 0} / 500
                                          </div>
                                      </div>
                                  </div>
                             </div>
                        </div>
                    </div>
                )}
            </div>
            )}

            {/* Add Client Modal */}
            <TailwindModal isOpen={modal} toggle={() => setModal(!modal)}>
                <div className="p-6">
                    <div className="flex items-start justify-between mb-5 border-b border-slate-100 pb-4">
                        <div className="flex items-center gap-3">
                            <div className="p-2 bg-blue-100 text-blue-600 rounded-lg">
                                <PlusCircle size={20} />
                            </div>
                            <h3 className="text-lg font-bold text-slate-800">Add New Client</h3>
                        </div>
                        <button onClick={() => { setModal(false); setClientModalError(''); }} className="text-slate-400 hover:text-slate-600 p-1">
                            <X size={20} />
                        </button>
                    </div>
                    <form className="space-y-4">
                        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Client ID<span className="text-red-500">*</span></label>
                                <TextField size="small" type="text" name="clientID" placeholder="Enter Client ID" value={state.clientID || ''} onChange={handleChange} className="w-full" required error={clientSubmitAttempted && !state.clientID} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Client Name<span className="text-red-500">*</span></label>
                                <TextField size="small" type="text" name="newClientName" placeholder="Enter Client Name" value={state.newClientName || ''} onChange={handleChange} className="w-full" required error={clientSubmitAttempted && !state.newClientName} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Start Date<span className="text-red-500">*</span></label>
                                <TextField size="small" type="date" name="startdate" value={state.startdate || ''} onChange={handleChange} className="w-full" required InputLabelProps={{ shrink: true }} error={clientSubmitAttempted && !state.startdate} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Geo</label>
                                <TextField size="small" type="text" name="clientGeo" placeholder="Client Geo" value={state.clientGeo || ''} onChange={handleChange} className="w-full" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">POC</label>
                                <TextField size="small" type="text" name="clientContact" placeholder="Enter POC" value={state.clientContact || ''} onChange={handleChange} className="w-full" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Phone</label>
                                <TextField size="small" type="number" name="clientPhone" placeholder="Enter Phone" value={state.clientPhone || ''} onChange={handleChange} className="w-full" sx={{ '& input[type=number]': { MozAppearance: 'textfield' }, '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button': { WebkitAppearance: 'none', margin: 0 } }} />
                            </div>
                            <div className="sm:col-span-2">
                                <label className="block text-sm font-medium text-slate-700 mb-1">Email<span className="text-red-500">*</span></label>
                                <TextField size="small" type="email" name="clientMail" placeholder="Enter email" value={state.clientMail || ''} onChange={handleChange} className="w-full" required error={(clientSubmitAttempted && !state.clientMail) || emailError === 'Enter valid Email!'} />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Client Parent</label>
                                <TextField size="small" type="text" name="clientParent" placeholder="Client Parent" value={state.clientParent || ''} onChange={handleChange} className="w-full" />
                            </div>
                            <div>
                                <label className="block text-sm font-medium text-slate-700 mb-1">Status<span className="text-red-500">*</span></label>
                                <TextField 
                                    select 
                                    size="small" 
                                    name="clientStatus" 
                                    value={state.clientStatus || ''} 
                                    onChange={handleChange} 
                                    required 
                                    className="w-full bg-white" 
                                    SelectProps={{ displayEmpty: true, MenuProps: { sx: { zIndex: 99999 } } }} 
                                    error={clientSubmitAttempted && !state.clientStatus}
                                    sx={{ 
                                        '& .MuiOutlinedInput-root': { minHeight: '38px' }, 
                                        '& .MuiSelect-select': { paddingTop: '6px', paddingBottom: '6px' } 
                                    }}
                                >
                                    <MenuItem value="" disabled hidden>Select Status</MenuItem>
                                    <MenuItem value="Active">Active</MenuItem>
                                    <MenuItem value="Inactive">Inactive</MenuItem>
                                </TextField>
                            </div>
                        </div>
                        {clientModalError && (
                            <div className="text-red-500 text-sm font-medium">
                                {clientModalError}
                            </div>
                        )}
                        <div className="flex justify-end gap-3">
                            <button type="button" className="px-5 py-2 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors font-medium text-sm" onClick={() => { setState(initialState); setClientModalError(''); setClientSubmitAttempted(false); setModal(false); }}>
                                Cancel
                            </button>
                            <button type="button" className={`px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium text-sm flex items-center gap-2 ${isDisabled ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={addNewClient} disabled={isDisabled}>
                                {isDisabled ? "Adding..." : "Add Client"}
                            </button>
                        </div>
                    </form>
                </div>
            </TailwindModal>

            {/* Projects Table Card */}
            {currentActiveTab === '3' && (
            <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
                <div className="p-4 sm:p-4 border-b border-slate-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                    <div className="flex items-center space-x-3">
                        <div className="p-2 bg-teal-100 text-teal-600 rounded-lg">
                            <Briefcase size={20} />
                        </div>
                        <div>
                            <h2 className="text-[16px] font-bold text-slate-800 m-0 leading-tight">Projects Overview</h2>
                            <p className="text-xs text-slate-500 font-medium mt-0.5 block m-0">Manage and view all projects</p>
                        </div>
                    </div>
                    <div className="w-full sm:w-auto flex flex-col sm:flex-row items-center gap-3">
                        <button type="button" className="px-4 py-2 bg-blue-600 text-white font-medium text-sm rounded-lg hover:bg-blue-700 whitespace-nowrap flex items-center gap-2" onClick={() => { clearData(); toggle('1'); }}>
                             <PlusCircle size={16} /> Add New Project
                        </button>
                    </div>
                </div>
                
                <div className="p-0 flex-1 flex flex-col mt-2">
                    <CentralizedTable
                        isLoading={isApiLoading}
                        getRowId={row => row.PROJECT_CODE}
                        rows={filteredRows}
                        columns={columns}
                        autoHeight
                        enableColumnPinning
                        renderTopToolbarCustomActions={() => (
                            <div className="flex items-center h-[56px] -ml-3">
                                <button
                                    type="button"
                                    onClick={() => setTableTab('All')}
                                    className={`relative h-full px-5 text-sm font-medium transition-colors duration-200 ${
                                        tableTab === 'All'
                                            ? 'text-blue-600'
                                            : 'text-slate-500 hover:text-slate-700'
                                    }`}
                                >
                                    All Projects ({rows.length})
                                    {tableTab === 'All' && (
                                        <span className="absolute bottom-0 left-0 h-[2px] w-full bg-blue-600" style={{ marginBottom: '-1px' }}></span>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setTableTab('Active')}
                                    className={`relative h-full px-5 text-sm font-medium transition-colors duration-200 ${
                                        tableTab === 'Active'
                                            ? 'text-blue-600'
                                            : 'text-slate-500 hover:text-slate-700'
                                    }`}
                                >
                                    Active ({rows.filter(r => r.PROJECT_STATUS === 'Open' || r.PROJECT_STATUS === 'Active').length})
                                    {tableTab === 'Active' && (
                                        <span className="absolute bottom-0 left-0 h-[2px] w-full bg-blue-600" style={{ marginBottom: '-1px' }}></span>
                                    )}
                                </button>
                                <button
                                    type="button"
                                    onClick={() => setTableTab('Inactive')}
                                    className={`relative h-full px-5 text-sm font-medium transition-colors duration-200 ${
                                        tableTab === 'Inactive'
                                            ? 'text-blue-600'
                                            : 'text-slate-500 hover:text-slate-700'
                                    }`}
                                >
                                    Inactive ({rows.filter(r => r.PROJECT_STATUS !== 'Open' && r.PROJECT_STATUS !== 'Active').length})
                                    {tableTab === 'Inactive' && (
                                        <span className="absolute bottom-0 left-0 h-[2px] w-full bg-blue-600" style={{ marginBottom: '-1px' }}></span>
                                    )}
                                </button>
                            </div>
                        )}
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                            columnPinning: { right: ['Action'] },
                        }}
                        muiTopToolbarProps={{
                            sx: {
                                minHeight: 40,
                                px: 1.5,
                                display: "flex",
                                alignItems: "center",
                                "& .MuiToolbar-root": {
                                    minHeight: "40px !important",
                                    alignItems: "center",
                                },
                                "& > .MuiBox-root": {
                                    alignItems: "center",
                                    p: 0.2,
                                },
                                borderBottom: "1px solid #e2e8f0",
                            },
                        }}
                        muiTableHeadCellProps={({ column }) => ({
                            sx: {
                                whiteSpace: "nowrap",
                                py: "8px",
                                px: column.getIndex() === 0 ? "16px" : "3px",
                                borderBottom: "1px solid #e2e8f0",
                                boxShadow: 'none !important',
                                '&::before': { 
                                    boxShadow: column.id === 'Action' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important' 
                                }
                            },
                        })}
                        muiTableBodyCellProps={({ cell }) => ({
                            sx: {
                                py: "8px",
                                borderBottom: "1px solid #e2e8f0",
                                px: cell.column.getIndex() === 0 ? '16px' : "3px",
                                maxWidth: cell.column.getSize(),
                                whiteSpace: 'nowrap',
                                overflow: cell.column.id === 'Action' ? 'visible' : 'hidden',
                                textOverflow: cell.column.id === 'Action' ? 'clip' : 'ellipsis',
                                boxShadow: 'none !important',
                                backgroundColor: cell.column.id === 'Action' ? '#fff !important' : 'inherit',
                                '&::before': { 
                                    boxShadow: cell.column.id === 'Action' ? '-4px 0 10px rgba(0,0,0,0.05) !important' : 'none !important'
                                }
                            },
                        })}
                        pageSizeOptions={[5, 10, 25, 50]}
                        hideFooterSelectedRowCount
                    />
                </div>
            </div>
            )}

            {/* Team Members Modal */}
            <TailwindModal isOpen={teamModal} toggle={() => setTeamModal(!teamModal)}>
                <div className="p-6">
                    <div className="flex items-start justify-between mb-5">
                        <div className="flex items-center gap-3">
                            <div className="p-2.5 bg-blue-50 text-blue-600 rounded-xl">
                                <Users size={22} />
                            </div>
                            <div>
                                <h3 className="text-lg font-bold text-slate-800">Team Members ({modalTeamMembers.length})</h3>
                                <p className="text-sm text-slate-500 mt-0.5">All members assigned to this project</p>
                            </div>
                        </div>
                        <button onClick={() => setTeamModal(false)} className="text-slate-400 hover:text-slate-600 p-1">
                            <X size={20} />
                        </button>
                    </div>

                    <div className="relative mb-4">
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <Search size={18} className="text-slate-400" />
                        </div>
                        <input
                            type="text"
                            className="block w-full pl-10 pr-10 py-2.5 border border-slate-200 rounded-xl text-sm placeholder-slate-400 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Search by name or email..."
                            value={teamSearchTerm}
                            onChange={(e) => setTeamSearchTerm(e.target.value)}
                        />
                        <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <svg className="w-4 h-4 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
                            </svg>
                        </div>
                    </div>

                    <div className="max-h-[50vh] overflow-y-auto pr-1 custom-scrollbar">
                        {modalTeamMembers.filter(email => {
                            let emp = employees?.find(e => e.EMP_WORK_EMAIL === email);
                            let name = emp ? emp.EMP_NAME : email;
                            return name.toLowerCase().includes(teamSearchTerm.toLowerCase()) || email.toLowerCase().includes(teamSearchTerm.toLowerCase());
                        }).map((email, index) => {
                            let emp = employees?.find(e => e.EMP_WORK_EMAIL === email);
                            let name = emp ? emp.EMP_NAME : email;
                            return (
                                <div key={index} className="flex items-center gap-3 py-3.5 border-b border-slate-100 last:border-0 hover:bg-slate-50/50 transition-colors px-2 rounded-lg">
                                    <UserAvatar name={name} size={38} />
                                    <div>
                                        <p className="text-sm font-semibold text-slate-800">{name}</p>
                                        <p className="text-xs text-slate-500 font-medium mt-0.5">{email}</p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    <div className="mt-4 flex items-center justify-between pt-4 border-t border-slate-100">
                        <span className="text-sm font-medium text-slate-500">{modalTeamMembers.length} members</span>
                        <button onClick={() => setTeamModal(false)} className="px-5 py-2 border border-slate-200 text-slate-700 font-medium text-sm rounded-lg hover:bg-slate-50 transition-colors shadow-sm">
                            Close
                        </button>
                    </div>
                </div>
            </TailwindModal>
        </div>
    )
}

export default ProjectsTabSA
